import { FaroErrorBoundary } from '@grafana/faro-react';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './faro';
import reportWebVitals from './reportWebVitals';
import { store } from './store';

import './stylesheets/app.scss';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <FaroErrorBoundary>
        <BrowserRouter
          basename={process.env.PUBLIC_URL}
          future={{ v7_startTransition: false, v7_relativeSplatPath: false }}
        >
          <App />
        </BrowserRouter>
      </FaroErrorBoundary>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
